import './style/index.less';
import PasswordModifyDialog from './PasswordModifyDialog';

export default PasswordModifyDialog;
